import React from 'react';
import {useMediaQuery} from "react-responsive";

const useScreenSize = () => {
    const isMobile = useMediaQuery({ maxWidth: 900 })
    const isTablet = useMediaQuery({ maxWidth: 1100 })
    return {isMobile, isTablet}
};

export default useScreenSize;